import { copyToClipboard } from '@/utils/other';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'UUID',
    props: {
        uuid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            copiedTimer: 0
        };
    },
    computed: {
        copiedTooltipText() {
            return this.copiedTimer === 0 ? this.$t('global.copy') : this.$t('global.copied');
        },
        isMobile() {
            return 'ontouchstart' in window;
        }
    },
    methods: {
        formatString(str) {
            if (str.length > 6) {
                return str.slice(0, 3) + '...' + str.slice(-3);
            }
            return str;
        },
        copy() {
            copyToClipboard(this.uuid).then(() => {
                window.clearTimeout(this.copiedTimer);
                this.copiedTimer = window.setTimeout(() => {
                    this.copiedTimer = 0;
                }, 1500);
            });
        }
    }
});
